import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FiActivity, FiGitMerge, FiUsers } from 'react-icons/fi';

const ideas = [
  {
    icon: <FiGitMerge className="w-6 h-6" />,
    title: 'Continuity is the real advantage',
    description: 'The next AI advantage in real estate is not simply a better conversation. It is the ability to preserve buyer context and intent as the journey moves across channels and people.'
  },
  {
    icon: <FiActivity className="w-6 h-6" />,
    title: 'AI should move the journey forward',
    description: 'A useful system should do more than answer questions. It should understand what the buyer is trying to accomplish, reduce uncertainty and help determine the right next action.'
  },
  {
    icon: <FiUsers className="w-6 h-6" />,
    title: 'Human judgment remains part of the system',
    description: 'The goal is not to automate every interaction. AI should handle what machines do well and bring people in where judgment, negotiation, relationships and expertise matter.'
  }
];

const Vision = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  return (
    <section className="section-padding bg-white">
      <motion.div
        ref={ref}
        initial={{ opacity: 0 }}
        animate={inView ? { opacity: 1 } : { opacity: 0 }}
        transition={{ duration: 0.5 }}
        className="container-custom"
      >
        <div className="max-w-5xl mx-auto">
          <div className="max-w-3xl mb-12">
            <p className="text-sm uppercase tracking-[0.2em] text-gold font-semibold mb-3">Point of View</p>
            <h2 className="text-4xl md:text-5xl font-serif text-navy mb-5">The buyer journey is becoming an intelligence problem.</h2>
            <p className="text-lg text-charcoal leading-relaxed">
              Real estate has digitized many interactions without necessarily connecting them. I&apos;m interested in what changes when AI becomes an orchestration layer across the journey, not another isolated tool.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {ideas.map((idea) => (
              <div key={idea.title} className="bg-off-white rounded-xl p-7 border border-gray-100">
                <div className="text-gold mb-5">{idea.icon}</div>
                <h3 className="text-xl font-serif text-navy mb-3">{idea.title}</h3>
                <p className="text-charcoal leading-relaxed">{idea.description}</p>
              </div>
            ))}
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default Vision;
